import '../css/TicketBook.css';

export const SportsPage = () => {
    return (
        <>
<div className="TicketBookWrap">스포츠</div>
        </>
    )
}